
import { useState } from 'react';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { useScheduleSupabaseStore } from '@/store/api/scheduleSupabaseStore';
import { ClassFormData } from '../types/schedule.types';

export const useScheduleActions = (fetchClasses: () => Promise<void>) => {
  const { t } = useTranslation(['schedule', 'common']);
  const { addScheduledClass } = useScheduleSupabaseStore();
  
  // State for add class dialog
  const [addClassDialogOpen, setAddClassDialogOpen] = useState(false);
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedDateForEdit, setSelectedDateForEdit] = useState<Date>(new Date());
  

  // Handle save class
  const handleSaveClass = async (classData: ClassFormData): Promise<boolean> => {
    try {
      console.log("Saving class data:", classData);
      
      // Format the date for database storage
      const formattedDate = format(selectedDateForEdit, 'yyyy-MM-dd');
      
      const result = await addScheduledClass({
        name: classData.name,
        class_date: formattedDate,
        time: classData.time,
        instructor: classData.instructor,
        category_id: classData.category || classData.categoryId,
        capacity: classData.capacity,
        duration: classData.duration,
        course_id: classData.courseId,
        calendar_id: classData.calendarId ?? undefined
      });
      
      if (result) {
        // Refresh the classes after adding
        await fetchClasses();
        return true;
      } else {
        throw new Error('Failed to add class');
      }
    } catch (error) {
      console.error('Error adding class:', error);
      toast.error(t('errorAddingClass', { ns: 'common', defaultValue: 'Failed to add class' }));
      return false;
    }
  };

  // Handle add class
  const handleAddClass = (date: Date, time: string) => {
    setSelectedDateForEdit(date);
    setSelectedTime(time);
    setAddClassDialogOpen(true);
  };

  const handleAddClassDaily = (time: string) => {
    setSelectedTime(time);
    setAddClassDialogOpen(true);
  };

  return {
    // Dialog states
    addClassDialogOpen,
    setAddClassDialogOpen,
    selectedTime,
    selectedDateForEdit,
    
    // Action handlers
    handleSaveClass,
    handleAddClass,
    handleAddClassDaily
  };
};
